"use client";

import { useState, type FormEvent } from "react";
import { useRouter } from "next/navigation";
import { useToast } from "@/components/toast-provider";

export default function AdminLoginForm() {
  const router = useRouter();
  const { notify } = useToast();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setBusy(true);
    try {
      const response = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const result = (await response.json()) as { error?: string };
      if (!response.ok) {
        throw new Error(result.error ?? "No se pudo iniciar sesión.");
      }
      router.replace("/admin");
    } catch (loginError) {
      const message = loginError instanceof Error
        ? loginError.message
        : "No se pudo iniciar sesión. Inténtalo de nuevo.";
      setError(message);
      notify("error", message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="login-form" onSubmit={submit}>
      <label className="field">
        <span className="field-label">Usuario</span>
        <input
          type="text"
          autoComplete="username"
          required
          maxLength={32}
          value={username}
          onChange={(event) => setUsername(event.currentTarget.value)}
        />
      </label>
      <label className="field">
        <span className="field-label">Contraseña</span>
        <input
          type="password"
          autoComplete="current-password"
          required
          maxLength={200}
          value={password}
          onChange={(event) => setPassword(event.currentTarget.value)}
        />
      </label>
      {error && <p className="form-error" role="alert">{error}</p>}
      <button className="button button-dark" disabled={busy}>
        {busy ? "Entrando…" : "Entrar al taller"} <span aria-hidden="true">↗</span>
      </button>
      <p className="login-setup-hint">
        El usuario inicial se crea con ADMIN_PASSWORD en .env.local. Después podrás administrar accesos aquí.
      </p>
    </form>
  );
}
